'use strict';exports.__esModule = true;exports.BROKER_COMPANY_PHONE = exports.BROKER_COMPANY_EMAIL = exports.BROKER_COMPANY_LOGO = exports.BROKER_COMPANY_NAME_SHORT = exports.BROKER_COMPANY_NAME = undefined;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _company = require('../../redux/modules/company');





var _messageModal = require('../../redux/modules/messageModal');



var _shareModal = require('../../redux/modules/shareModal');

var _components = require('../../components');


var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);


var _BrokerCommunityContainer = require('./BrokerCommunityContainer.scss');var styles = _interopRequireWildcard(_BrokerCommunityContainer);
var _description = require('./description');



var _HeaderPhones = require('../../components/Company/HeaderPhones/HeaderPhones');var _HeaderPhones2 = _interopRequireDefault(_HeaderPhones);
var _ConsultationForm = require('../../components/Company/ConsultationForm/ConsultationForm');var _ConsultationForm2 = _interopRequireDefault(_ConsultationForm);

var _services = require('../../services');
var _makeSharingUrl = require('../../utils/makeSharingUrl');var _makeSharingUrl2 = _interopRequireDefault(_makeSharingUrl);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // styles

var BROKER_COMPANY_NAME = exports.BROKER_COMPANY_NAME = 'רשת ברוקר - סטנדרט חדש בנדל״ן';
var BROKER_COMPANY_NAME_SHORT = exports.BROKER_COMPANY_NAME_SHORT = 'רשת ברוקר';
var BROKER_COMPANY_LOGO = exports.BROKER_COMPANY_LOGO = 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/v1579103856/partners/broker_logo';
var BROKER_COMPANY_EMAIL = exports.BROKER_COMPANY_EMAIL = 'ben@broker-re.co.il';
var BROKER_COMPANY_PHONE = exports.BROKER_COMPANY_PHONE = '072-391-0001';var

BrokerCommunityContainer = function (_Component) {_inherits(BrokerCommunityContainer, _Component);function BrokerCommunityContainer() {var _temp, _this, _ret;_classCallCheck(this, BrokerCommunityContainer);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      captcha: null }, _this.









    openSuccessMessage = function () {return _this.props.openMessageModal({
        message:
        _react2.default.createElement('div', { className: 'successMessage' },
          _react2.default.createElement('span', null, _this.props.translate('companyPage', 'contactsForm', 'submitting_success'))),


        messageModalClassName: 'company-message-modal' });}, _this.


    formConsultationSubmitHandler = function (formValues) {var
      captcha = _this.state.captcha;

      _this.props.sendCompanyContactUsForm(Object.assign({},
      formValues, {
        captcha: captcha,
        receiver_name: BROKER_COMPANY_NAME_SHORT,
        to: BROKER_COMPANY_EMAIL,
        is_community_member: true }));

    }, _this.

    fetchReCaptchaToken = function (token) {
      _this.setState({ captcha: token });
    }, _this.

    renderConsultationForm = function (companyName, className, field_id) {return (
        _react2.default.createElement(_ConsultationForm2.default, {
          fetchReCaptchaToken: _this.fetchReCaptchaToken,
          locale: _this.props.locale,
          field_id: field_id,
          companyName: '\u05E8\u05E9\u05EA \u05D1\u05E8\u05D5\u05E7\u05E8',
          className: className,
          translate: _this.props.translate,
          onSubmit: _this.formConsultationSubmitHandler,
          isRtl: _this.props.isRtl,
          formSubmitting: _this.props.formSubmitting,
          formSubmitted: _this.props.formSubmitted,
          formConsultationError: _this.props.formError }));}, _this.



    renderShareButton = function () {
      var sharingData = {
        sharingUrl: (0, _makeSharingUrl2.default)('/professionals/broker', _this.props.locale),
        sharingTitle: BROKER_COMPANY_NAME };


      return (
        _react2.default.createElement(_components.ShareButtonsRow, {
          sharingData: sharingData,
          isMobile: _this.props.isMobile,
          isNative: _this.props.isNative,
          locale: _this.props.locale,
          copyLinkTitle: '' + _this.props.translate('copyLink'),
          shareTitle: '' + _this.props.translate('companyPage', 'shareTitle'),
          className: 'companySocialIcons',
          isHideShareTitle: true }));


    }, _this.

    renderDescription = function () {return (
        _react2.default.createElement('div', { className: styles.description },
          _react2.default.createElement('div', { className: styles.descriptionTitle }, BROKER_COMPANY_NAME),
          _react2.default.createElement('div', null, _description.communityDescriptionMain),

          _react2.default.createElement('br', null),
          _react2.default.createElement('div', { className: styles.descriptionTitle }, '\u05DC\u05DE\u05D4 \u05D1\u05E8\u05D5\u05E7\u05E8?'),
          _react2.default.createElement('div', { className: styles.listBlock },
            _description.communityDescriptionAdvantages.map(function (item) {return (
                _react2.default.createElement('li', null,
                  _react2.default.createElement('span', { className: 'icon icon-check' }),
                  _react2.default.createElement('strong', null, item[0]),
                  item[1]));}))));}, _this.






    renderDesktopContent = function () {return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.topWrap, styles.brokerWrap) },
          _react2.default.createElement('span', { className: styles.bgCover }),
          _react2.default.createElement('div', { className: styles.container },
            _react2.default.createElement('div', { className: styles.content },
              _react2.default.createElement('div', { className: styles.logo }, _react2.default.createElement('img', { src: BROKER_COMPANY_LOGO, alt: 'BROKER_COMPANY_LOGO' })),
              _react2.default.createElement('div', null,
                _react2.default.createElement('h1', { className: styles.title }, BROKER_COMPANY_NAME),
                _react2.default.createElement(_HeaderPhones2.default, {
                  translate: _this.props.translate('companyPage'),
                  phoneNumber: BROKER_COMPANY_PHONE,
                  locale: _this.props.locale,
                  isMobile: _this.props.isMobile }),

                _react2.default.createElement('br', null),
                _this.renderConsultationForm(BROKER_COMPANY_NAME, 'headerTopForm', 'broker_company_name_form'),

                _this.renderShareButton(),
                _react2.default.createElement('br', null),
                _react2.default.createElement('div', { className: styles.infoMessage }, '\u05DE\u05E9\u05D5\u05D5\u05E7\u05D9\u05DD \u05E0\u05D3\u05DC\u05F4\u05DF \u05D1-4 \u05E9\u05E4\u05D5\u05EA'))))));}, _temp), _possibleConstructorReturn(_this, _ret);}BrokerCommunityContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {if (!this.props.formSubmitted && nextProps.formSubmitted) {this.props.reset();this.openSuccessMessage();}};BrokerCommunityContainer.prototype.






  render = function render() {
    return (
      _react2.default.createElement('div', null,
        this.renderDesktopContent(),
        this.renderDescription()));


  };return BrokerCommunityContainer;}(_react.Component);


BrokerCommunityContainer.propTypes = {
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  isNative: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  formSubmitted: _propTypes2.default.bool,
  formSubmitting: _propTypes2.default.bool,
  formError: _propTypes2.default.object,
  isModalShareOpen: _propTypes2.default.bool,
  sendCompanyContactUsForm: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  location: _propTypes2.default.object,
  reset: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(state) {return {
    locale: state.lang.locale,
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    isMobile: state.windowDimentions.isMobile,
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    formSubmitted: state.company.formSubmitted,
    formSubmitting: state.company.formSubmitting,
    formError: state.company.formError,
    isNative: state.native.isNative,
    isModalShareOpen: state.shareModal.isModalShareOpen };};


var mapDispatchToProps = {
  openCompanyContactModal: _company.openCompanyContactModal,
  closeCompanyContactModal: _company.closeCompanyContactModal,
  sendCompanyContactUsForm: _company.sendCompanyContactUsForm,
  openMessageModal: _messageModal.openMessageModal,
  hideMessageModal: _messageModal.hideMessageModal,
  reset: _company.reset,
  openModalShare: _shareModal.openModalShare,
  hideModalShare: _shareModal.hideModalShare };exports.default =


(0, _reactRedux.connect)(
mapStateToProps,
mapDispatchToProps)(
BrokerCommunityContainer);


//////////////////
// WEBPACK FOOTER
// ./src/containers/BrokerCommunityContainer/BrokerCommunityContainer.js
// module id = 1236
// module chunks = 0